import DeviceLoanApprovalTable from "./ApprovalTable";

const CompanyDeviceLoanApproval = () => <DeviceLoanApprovalTable level="company" />;

export default CompanyDeviceLoanApproval;
